import fitvids from "fitvids";
import toTop from "./to-top";
import fontawesome from "./vendor/fontawesome";
import modernizr from "./vendor/modernizr-custom";
import touch from "./touch";
import navigation from "./navigation";
import accordion from "./accordion";
import slider from "./slider";
import remodal from "./remodal";
import categorySelect from "./category-select";
import smoothScroll from "./smooth-scroll";
import siteSwitcher from "./site-switcher";
import imageMenu from "./image-menu"
import fancyHeader from "./fancy-header"
import compareImageSlider from "./compare-image-slider"
import wrapTables from "./wrap-tables"
import evenHeight from "./even-height"
window.jQuery = window.$ = jQuery;

jQuery(
    (function($) {
        $(document).ready(() => {
            /**
             * Setup Font Awesome icons
             * @see https://fontawesome.com/icons
             */
            fontawesome();

            /**
             * Setup Fivids
             * @see https://www.npmjs.com/package/fitvids
             */
            fitvids(".js-fitvid");

            /**
             * Setup back to top
             */
            toTop();

            /**
             * Setup navigation
             */
            navigation();

            /**
             * Setup accordions
             */
            accordion();

            /**
             * Setup modernizr for touch events
             */
            modernizr();

            /**
             * Setup modernizr for touch events
             */
            touch();

            /**
             * Testimonial Slider
             */
            slider();

            /**
             * Close modals and stop video from playing
             */
            remodal();

            /**
             * Roll category select on mofile
             */
            categorySelect();


            compareImageSlider();

            siteSwitcher();

             /**
             * Setup smooth scroll for sub navigations
             */
            smoothScroll();

            imageMenu();

            fancyHeader();

            wrapTables();

            evenHeight();


        });
    })(jQuery)
);
